import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchRedeemCashResultsData } from '../../services/api';
import '../../styles/output.css';
import '../../styles/index.css';
import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function RedeemCashResults() {
  const [postData, setWidgetData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  // POSTREDEMPTION is a state-changing call -- it redeems the member's entire
  // balance. StrictMode runs mount effects twice in development, which would
  // redeem once and then fail on a zero balance, reporting a false error.
  // A ref survives StrictMode's simulated remount, so this fires exactly once.
  const hasRedeemed = useRef(false);

  useEffect(() => {
    document.title = "Redeem Member Rewards for Cash | MAX Credit Union";
    const getData = async () => {
      try {
        const result = await fetchRedeemCashResultsData();
        setWidgetData(result);
      } catch (err) {
        console.error(err);
      }
    };
    if (!hasRedeemed.current) {
      hasRedeemed.current = true;
      getData();
    }

    const handleResize = () => {
      if (window.innerWidth < 600) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize(); // Set initial state

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (error) return <div>Error: {error.message}</div>;
  if (!postData) return <div className='text-center'>Loading...</div>;

  return (
    <div style={{ display: 'flex' }}>
      <SideMenu menuItems={menuItems} />
      <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
        <Header name="Redeem for Cash" />
        <div class='sb-body'>
        {postData?.post_result === 'SUCCESS' ? (
            <div>
                <header className="mb-8">
                <div className="sm:max-w-3xl mx-auto md:grid md:grid-cols-1 md:gap-4">
                <h1 className="text-left sm:text-center text-xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4 tracking-tight">Redemption Successful</h1>
            
                <p className="p-size125 text-left sm:text-center text-base sm:text-xl text-gray-700 mb-2 sm:mb-4">Your funds were deposited into Share { postData.post_share_id }.</p>
                
                </div>
            </header>
            
            <section>
                <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-1 md:gap-4">
            
                <div className="bg-green-100 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                    <p className="p-redeem text-green-900 text-lg text-center">You redeemed { postData.post_redeemed } points for</p>
                    <h2 className="text-h2-redeem text-green-900 text-5xl text-center tracking-tighter relative"><span className="absolute text-2xl -ml-4">$</span>{ postData.post_redeemed_worth }</h2>
            
                    </div>
                </div>
                </div>
              </section>
            </div>
        ) : postData?.post_result === 'UNAVAILABLE' ? (
            <header className="mb-8">
                <div className="sm:max-w-3xl mx-auto">
                <h1 className="text-left sm:text-center text-xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4 tracking-tight">Redemption Unavailable</h1>

                <p className=".p-size125 text-left sm:text-center text-base sm:text-xl text-gray-700 mb-2 sm:mb-4">Points Redemption is not available at this time. <br />Please try again later.</p>
                
                </div>
            </header>

        ) : (
            <header class="mb-8">
            <div class="sm:max-w-3xl mx-auto">
              <h1 class="text-left sm:text-center text-xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-4 tracking-tight">Redemption Error</h1>
        
              <p class="p-size125 text-left sm:text-center text-base sm:text-xl text-gray-700 mb-2 sm:mb-4">There was an error redeeming your points. <br />Please try again later.</p>
              
            </div>
          </header>
        
        )}

        </div>
      </div>
    </div>
  );
}

export default RedeemCashResults;